import React from 'react';
import './TierPyramidDiagram.css';

/**
 * Static example of the division-ladder pyramid for About / help.
 * Shows how tiers fan out and where a new player typically lands.
 */
function TierPyramidDiagram() {
  return (
    <figure className="tier-pyramid-diagram">
      <div className="tier-pyramid-diagram__visual" aria-hidden="true">
        <div className="tier-pyramid-diagram__row">
          <span className="tier-pyramid-diagram__cell tier-pyramid-diagram__cell--apex">
            <span className="tier-pyramid-diagram__cell-title">1-1</span>
            <span className="tier-pyramid-diagram__cell-meta">Top · champion cell</span>
          </span>
        </div>
        <div className="tier-pyramid-diagram__connectors" aria-hidden="true">
          <span className="tier-pyramid-diagram__fork" />
        </div>
        <div className="tier-pyramid-diagram__row">
          <span className="tier-pyramid-diagram__cell">
            <span className="tier-pyramid-diagram__cell-title">2-1</span>
            <span className="tier-pyramid-diagram__cell-meta">Tier 2</span>
          </span>
          <span className="tier-pyramid-diagram__cell">
            <span className="tier-pyramid-diagram__cell-title">2-2</span>
            <span className="tier-pyramid-diagram__cell-meta">Tier 2</span>
          </span>
        </div>
        <div className="tier-pyramid-diagram__connectors tier-pyramid-diagram__connectors--wide" aria-hidden="true">
          <span className="tier-pyramid-diagram__fork" />
          <span className="tier-pyramid-diagram__fork" />
        </div>
        <div className="tier-pyramid-diagram__row">
          <span className="tier-pyramid-diagram__cell">
            <span className="tier-pyramid-diagram__cell-title">3-1</span>
            <span className="tier-pyramid-diagram__cell-meta">Tier 3</span>
          </span>
          <span className="tier-pyramid-diagram__cell tier-pyramid-diagram__cell--you">
            <span className="tier-pyramid-diagram__cell-title">3-2</span>
            <span className="tier-pyramid-diagram__cell-meta">You land here</span>
          </span>
          <span className="tier-pyramid-diagram__cell">
            <span className="tier-pyramid-diagram__cell-title">3-3</span>
            <span className="tier-pyramid-diagram__cell-meta">Tier 3</span>
          </span>
          <span className="tier-pyramid-diagram__cell">
            <span className="tier-pyramid-diagram__cell-title">3-4</span>
            <span className="tier-pyramid-diagram__cell-meta">Tier 3</span>
          </span>
        </div>
        <p className="tier-pyramid-diagram__flow">
          <span className="tier-pyramid-diagram__flow-up">↑ 1st promotes</span>
          <span className="tier-pyramid-diagram__flow-down">7th / 8th drop ↓</span>
        </p>
      </div>
      <figcaption className="tier-pyramid-diagram__caption">
        Example ladder: one champion cell at the top, more divisions as you go down. Each cell is an
        8-player group. Between season splits, 1st can climb up and bottom places can drop down.
      </figcaption>
    </figure>
  );
}

export default TierPyramidDiagram;
